<template>

  <div class="vx-row">
    <div class="vx-col w-2/3">
      <vs-card>
        <vs-input v-model="name" class="w-full" placeholder="Naam"></vs-input>
      </vs-card>
      <vs-card class="mb-4">
        <div slot="header">
          <h5>Prijs</h5>
        </div>
        <div class="flex">
          <vs-input icon="euro" v-model="price" class="w-5/6" placeholder="Prijs"></vs-input>
          <vs-select v-model="vat" class="w-1/6">
            <vs-select-item v-for="(item, index) in [{label: '9%', value: 9},{label: '21%', value: 21}]" :key="index"
                            :value="item.value" :text="item.label"></vs-select-item>
          </vs-select>
        </div>
      </vs-card>
      <vs-card class="mb-4">
        <div slot="header">
          <h5>Beschrijving</h5>
        </div>
        <div>
          <vs-textarea v-model="description" height="250px"></vs-textarea>
        </div>
      </vs-card>
      <vs-card class="mb-4">
        <div slot="header">
          <h5>Opties</h5>
        </div>
        <div>
          <vs-checkbox v-model="selectedAddonCategories" multiple v-for="addonCat in addonCategories" :key="addonCat.id"
                       :vs-value="addonCat.id" class="pb-2">
            {{ addonCat.name }}
            <div>
              <small v-for="(addon, index) in addonCat.addons" :key="addon.id">{{ addon.name }}<span v-if="addon.price"> (€{{
                  addon.price
                }})</span><span v-if="index !== addonCat.addons.length-1">, </span></small>
            </div>
          </vs-checkbox>
        </div>
      </vs-card>
    </div>
    <div class="vx-col w-1/3">
      <vs-button @click="createProduct" class="w-full mb-6">Opslaan</vs-button>
      <vs-card>
        <div slot="header">
          <h5>Categorien</h5>
        </div>
        <div>
          <vs-radio v-for="cat in categories" :key="cat.id" class="w-full" :vs-value="cat" v-model="category">
            {{ cat.name }}
          </vs-radio>
        </div>
      </vs-card>
      <vs-card>
        <div slot="header">
          <h5>Afbeelding</h5>
        </div>
        <div>
          <vs-upload @change="handleImageUpload" @on-delete="image = null"/>
        </div>
      </vs-card>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      position: '',
      vat: 9,
      name: '',
      description: '',
      price: '',
      category: '',
      addonCategories: [],
      selectedAddonCategories: [],
      image: null,
      categories: []
    };
  },
  created() {
    this.getProductCategories(null);
    this.getProductAddonCategories(null);
  },
  mounted() {
    console.log("INit");
    this.$events.listen("company-selected", event => {
      this.getProductCategories(event);
      this.getProductAddonCategories(event);
    });
  },
  computed: {
    imageUrl: function () {
      if (this.image != null) {
        return URL.createObjectURL(this.image);
      }
    },
    staffRoute() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem('stafftoken') !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem('stafftoken') !== null) {
          return true;
        }
        return false;
      }
    },
  },
  methods: {
    handleImageUpload: function (e, f) {
      this.image = f[0];
    },
    getProductCategories(company) {
      let url = null;
      if (company !== null) {
        url = this.staffRoute ? '/v1/company/' + company.slug + '/product-categories' : '/v1/company/' + company.slug + '/product-categories';
      } else {
        url = this.staffRoute ? '/v1/company/' + this.$route.params.slug + '/product-categories' : '/v1/company/' + this.$route.params.slug + '/product-categories';
      }
      console.log("Loading product categories");
      this.$http.get(url).then((response) => {
        if (this.staffRoute) {
          this.category = response.data.data[0];
          this.categories = response.data.data;
        } else {
          this.category = response.data[0];
          this.categories = response.data;
          console.log(response.data);
        }
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    },
    getProductAddonCategories: function (company) {
      if (company !== null) {
        var url = this.staffRoute ? '/v1/company/' + company.slug + '/product-category-addons' : '/v1/company/' + company.slug + '/product-category-addons';
      } else {
        var url = this.staffRoute ? '/v1/company/' + this.$route.params.slug + '/product-category-addons' : '/v1/company/' + this.$route.params.slug + '/product-category-addons';
      }
      this.$http.get(url).then((response) => {
        this.addonCategories = response.data;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    },
    createProduct: function () {
      let formData = new FormData();

      formData.append('name', this.name);
      formData.append('description', this.description);
      formData.append('position', this.position);
      formData.append('vat', this.vat);
      formData.append('image', this.image);
      formData.append('price', this.price);
      if (this.category) {
        formData.append('category', this.category.id);
      } else {
        formData.append('category', null);
      }
      formData.append('addoncategories', JSON.stringify(this.selectedAddonCategories));

      let url = this.staffRoute ? '/v1/company/' + this.$route.params.slug + '/product/create' : '/v1/company/' + this.$route.params.slug + '/product/create';
      this.$http.post(url, formData).then((response) => {
        console.log(response);
        this.$router.push({'name': 'companies-products'});
        this.$vs.notify({
          title: 'Success',
          text: 'Succesvol opgeslagen',
          color: 'success'
        });
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    }
  }
};
</script>

<style>
.ht-image {
  width: auto;
}

.img-upload,
.con-input-upload {
  width: 100%;
  margin-left: 0px;
  margin-top: 0px;
}
</style>
